// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "现代控制理论",
        "tec": "李海波",
        "week": "1-6周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘宁",
        "week": "18周",
        "add": "教学楼C座111教务"
      }
    ],
    [
      {
        "sub": "PLC原理及应用",
        "tec": "张玉艳",
        "week": "1-11,13周",
        "add": "实训楼F座420自实验室"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘宁",
        "week": "18周",
        "add": "教学楼C座111教务"
      }
    ],
    {
      "sub": "控制系统数字仿真",
      "tec": "刘宁",
      "week": "7-11,13周",
      "add": "实训楼C座108"
    },
    0,
    0
  ],
  "2": [
    [
      {
        "sub": "工业控制组态软件应用技术",
        "tec": "张娜",
        "week": "9-11,13周",
        "add": "实训楼F座420自实验室"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘宁",
        "week": "18周",
        "add": "教学楼C座111教务"
      }
    ],
    [
      {
        "sub": "单片机原理及应用",
        "tec": "庞新富",
        "week": "1-8周",
        "add": "实训楼F座420自实验室"
      },
      {
        "sub": "工业控制组态软件应用技术",
        "tec": "张娜",
        "week": "9-11,13周",
        "add": "实训楼F座420自实验室"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘宁",
        "week": "18周",
        "add": "教学楼C座111教务"
      }
    ],
    {
      "sub": "检测技术及仪表",
      "tec": "于红霞",
      "week": "1-11,13周",
      "add": "教学楼C座113教务"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "徐凤莉",
        "week": "1-8周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "徐凤莉",
        "week": "9-11,13周",
        "add": "教学楼C座113教务"
      }
    ],
    {
      "sub": "现代控制理论",
      "tec": "李海波",
      "week": "1-6周",
      "add": "教学楼C座110教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "工业控制组态软件应用技术",
      "tec": "张娜",
      "week": "9-11,13周",
      "add": "实训楼F座420自实验室"
    },
    [
      {
        "sub": "单片机原理及应用",
        "tec": "庞新富",
        "week": "1-8周",
        "add": "实训楼F座420自实验室"
      },
      {
        "sub": "工业控制组态软件应用技术",
        "tec": "张娜",
        "week": "9-11,13周",
        "add": "实训楼F座420自实验室"
      }
    ],
    {
      "sub": "检测技术及仪表",
      "tec": "于红霞",
      "week": "1-11,13周",
      "add": "教学楼C座110教务"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "PLC原理及应用",
      "tec": "张玉艳",
      "week": "1-11,13周",
      "add": "实训楼F座420自实验室"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "徐凤莉",
        "week": "1-8周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "徐凤莉",
        "week": "9-11,13周",
        "add": "教学楼A座118电力"
      }
    ],
    [
      {
        "sub": "就业创业指导",
        "tec": "许文利陈晓红",
        "week": "1-5周",
        "add": "教学楼C座111教务"
      },
      {
        "sub": "控制系统数字仿真",
        "tec": "刘宁",
        "week": "7-11,13周",
        "add": "实训楼C座108"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
